import { NextPageContext } from "next";
import ErrorNext, { ErrorProps } from "next/error";

function Error({ statusCode, err }: any) {
  console.error(err);
  return <ErrorNext statusCode={statusCode} />;
}

Error.getInitialProps = ({ res, err }: NextPageContext) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode, err };
};

export default Error;
